module.exports = __webpack_public_path__ + "img/20200713-5.8810d225.png";